<template>
	<v-container fill-height fluid class="text-center">
		<v-row no-gutters justify="center" align="center">
			<div class="img-magnifier-container">
				<img
					id="img-magnifier"
					style="width:30vw;height:auto;"
					:src="getImgUrl(loadImage)"
					@load="onImgLoad"
				/>
			</div>
		</v-row>
		<div
			v-if="checkImgSource(loadImage)"
			class="ma-6"
			style="left:0;bottom:0; position:fixed; font-size:0.7rem;"
		>
			{{ $t("d.credit") }}
		</div>
	</v-container>
</template>

<script>
export default {
	name: "PuzzleMagnify",
	props: { loadImage: String, magZoom: Number },
	data() {
		return { magnification: 3 };
	},
	mounted() {
		this.magnification = this.magZoom;
	},
	methods: {
		checkImgSource(i) {
			return i == "map-large-1.jpg" ||
				i == "map-large-2.jpg" ||
				i == "map-large-3.jpg" ||
				i == "map-large-4.jpg" ||
				i == "map-large-5.jpg"
				? true
				: false;
		},

		onImgLoad() {
			this.magImg();
		},
		getImgUrl(src) {
			let images = require.context("../assets/images/");
			if (typeof src !== "undefined") {
				this.avatarImgSrc = src;
			}

			return images("./" + this.avatarImgSrc);
		},
		magImg: function() {
			this.magnify("img-magnifier", this.magnification);
		},
		magnify: function(imgID, zoom) {
			let img, glass, w, h, bw;
			img = document.getElementById(imgID);

			/* Create magnifier glass: */
			glass = document.createElement("DIV");
			glass.setAttribute("class", "img-magnifier-glass");

			/* Insert magnifier glass: */
			img.parentElement.insertBefore(glass, img);

			/* Set background properties for the magnifier glass: */
			glass.style.backgroundImage = "url('" + img.src + "')";
			glass.style.backgroundRepeat = "no-repeat";
			glass.style.backgroundSize =
				img.width * zoom + "px " + img.height * zoom + "px";
			bw = 2;
			w = glass.offsetWidth / 2;
			h = glass.offsetHeight / 2;

			/* Execute a function when someone moves the magnifier glass over the image: */
			glass.addEventListener("mousemove", moveMagnifier);
			img.addEventListener("mousemove", moveMagnifier);

			/*and also for touch screens:*/
			glass.addEventListener("touchmove", moveMagnifier);
			img.addEventListener("touchmove", moveMagnifier);
			function moveMagnifier(e) {
				let pos, x, y;
				/* Prevent any other actions that may occur when moving over the image */
				e.preventDefault();
				/* Get the cursor's x and y positions: */
				pos = getCursorPos(e);
				x = pos.x;
				y = pos.y;
				/* Prevent the magnifier glass from being positioned outside the image: */
				if (x > img.width - w / zoom) {
					x = img.width - w / zoom;
				}
				if (x < w / zoom) {
					x = w / zoom;
				}
				if (y > img.height - h / zoom) {
					y = img.height - h / zoom;
				}
				if (y < h / zoom) {
					y = h / zoom;
				}
				/* Set the position of the magnifier glass: */
				glass.style.left = x - w + "px";
				glass.style.top = y - h + "px";
				/* Display what the magnifier glass "sees": */
				glass.style.backgroundPosition =
					"-" + (x * zoom - w + bw) + "px -" + (y * zoom - h + bw) + "px";
			}

			function getCursorPos(e) {
				let a,
					x = 0,
					y = 0;
				e = e || window.event;
				/* Get the x and y positions of the image: */
				a = img.getBoundingClientRect();
				/* Calculate the cursor's x and y coordinates, relative to the image: */
				x = e.pageX - a.left;
				y = e.pageY - a.top;
				/* Consider any page scrolling: */
				x = x - window.pageXOffset;
				y = y - window.pageYOffset;
				return { x: x, y: y };
			}
		},
	},
};
</script>

<style lang="scss" scoped>
::v-deep {
	& .img-magnifier-container {
		position: relative;
		z-index: 2;
		width: 100%;
	}
	& .img-magnifier-glass {
		left: 25%;
		top: 25%;
		position: absolute;
		border-radius: 50%;
		width: 300px;
		height: 300px;
		background-color: #111;
		&::before {
			content: "";
			background-image: url("../assets/images/glass.png");
			background-size: contain;
			left: -2px;
			top: -2px;
			width: 570px;
			height: 560px;
			position: absolute;
		}
	}
}
</style>
